import { css } from 'styled-components';
import { innerBorder } from '@doltech/utils/lib/css-style';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';

export const stateStyles = css`
  background-color: transparent;
  ${innerBorder('2px solid transparent')}

  .timer-clock {
    color: ${colorsV2.black60};
  }

  .timer-text {
    color: ${colorsV2.black80};
  }

  &.time-up-warning {
    background-color: ${colorsV2.yellow10};
    ${innerBorder(`2px solid ${colorsV2.yellow100}`)}

    .timer-clock {
      color: ${colorsV2.yellow120};
    }

    .timer-text {
      color: ${colorsV2.yellow120};
    }
  }

  &.time-up-danger {
    background-color: ${colorsV2.red10};
    ${innerBorder(`2px solid ${colorsV2.red100}`)}

    .timer-clock {
      color: ${colorsV2.red100};
    }

    .timer-text {
      color: ${colorsV2.red100};
    }
  }

  &.paused {
    background-color: ${colorsV2.blue10};
    ${innerBorder('2px solid transparent')}

    .timer-clock {
      color: ${colorsV2.black60};
    }

    .timer-text {
      color: ${colorsV2.black80};
    }
  }
`;
